import React from 'react';
import { Link } from 'react-router-dom';
export default function NotFoundPage() {
  return (
    <div className="page" style={{textAlign:'center',paddingTop:120,paddingBottom:80}}>
      <div style={{fontSize:80,marginBottom:16}}>🥻</div>
      <h1 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(2rem,5vw,4rem)',color:'#7a1f1f',fontStyle:'italic',marginBottom:12}}>Page Not Found</h1>
      <p style={{color:'#8a7968',fontSize:16,marginBottom:32}}>The page you're looking for doesn't exist.</p>
      <Link to="/" className="btn btn-primary">Back to Home</Link>
    </div>
  );
}
